import { useMemo } from 'react';
import getDeviceType from '@utility/deviceType';

/**
 * Memoize the getDeviceType() call so it only runs when deviceInfo changes,
 * not on every render. Returns stable primitives for use in memo comparisons.
 *
 * @param {object} deviceInfo — from Redux oauth.deviceInformation
 */
export function useDeviceType(deviceInfo) {
  return useMemo(() => getDeviceType(), [deviceInfo]);
}
